<template>
   <div v-if="user.verified == false" class="bg-red-600">

        <div class="flex flex-col justify-center items-center w-full">

          <div class="mt-2 lg:mt-5">
            <label><strong>{{$t('profile.verifyNumber')}}: {{user.phone}}</strong></label>
          </div>

          <div>

            <div>

              <input v-model="code" type="text"/> 
            </div>

            <div class="w-full flex justify-center">

                <button @click="sendToken"
                class="mt-2 lg:mt-5 w-40 h-8 lg:w-1/3 lg:rounded-full text-xs rounded bg-pink-500 text-white font-bold p-2 border-blue-500 border">

                {{$t('profile.submitCode')}}</button>
            </div>
          </div>

          <div class="w-full flex flex-row items-center justify-center h-20 text-center">

            <div class="flex flex-col items-center lg:justify-center w-20 lg:w-32 mb-5 lg:mb-0">
            
              <input type="radio" value="1" v-model="language">
              <label class="text-pink-800">{{$t('profile.englishLanguage')}}</label>
            </div>

            <div class="flex flex-col items-center justify-center w-20 lg:w-32 mb-5 lg:mb-0">

              <input type="radio" value="2" v-model="language">
              <label class="text-pink-800">{{$t('profile.arabicLanguage')}}</label>
            </div>
          </div>

          <div>

            <button @click="sendCode"
            class="mt-2 mb-2 lg:mb-5 lg:mt-5 w-40 h-8 lg:w-1/3 lg:rounded-full text-xs rounded bg-pink-500 text-white font-bold p-2 border-blue-500 border">

            {{$t('profile.resendCode')}}</button>
          </div>
        </div>
      </div>

</template>

<script>

// import axios from '@/classes/myAxios'
import axios from '@/classes/myAxios'


import authHttpHelper from '../auth/auth-http-helper'
import componentsHelpers from '../classes/componentHelpers';

export default {

    mounted(){
        
        if(localStorage.hasOwnProperty('pleaseWaitCode')){

          this.pleaseWaitCode = localStorage.getItem('pleaseWaitCode');
        }
    },

    props:{

        user:{

            type: Object
        },

        callReload: {
          
          type: Function
        }
    },

    methods: {

      changeFlag(){

        
        this.pleaseWaitCode = false;
      },

      async sendCode(){


        try{

          if(this.pleaseWaitCode == true){
            
            componentsHelpers.toastIt(this.$toasted, 'Please wait for at least three minutes', 3, 'outline', true);

            return;
          }

          const sendCodeResults = await axios({method: 'post',
        
          url: '/pnadiapi/profile/sendSMS',

          data: {
            
            key: authHttpHelper.getKey(),
            userId: this.user.id,
            language: this.language
          }});

          componentsHelpers.toastIt(this.$toasted, 'You might receive an international phone call to receive the code', 1, 'outline', true);

          this.pleaseWaitCode = true;
        }
        catch(error){

          if(error.message.includes(`code 425`)){

              componentsHelpers.toastIt(this.$toasted, 'You have to wait at least five minutes, and then you can try again',
               3, 'outline', true);
          }else{

            componentsHelpers.sendError(this.$apollo, this.user.id,'Profile', 'VerifyCode', 'SendCode', error);

            componentsHelpers.toastIt(this.$toasted, 'Something went wrong. Please try again', 3, 'outline', true);

          }

        }

        setTimeout(function(){

          this.pleaseWaitCode = false;
              
          },180000);
      },

      async sendToken(){

        if(this.code.length < 4){

          componentsHelpers.toastIt(this.$toasted, 'Please enter a valid code', 3, 'outline', true);

          return;
        }

        // console.log(`in send code with code: ${this.code}`);
        try{
            


            this.pleaseWait = true;

            const changeFlag = this.changeFlag


            const sendCodeResults = await axios({method: 'post',
          
            url: '/pnadiapi/profile/verifySMS',

            data: {
              
            key: authHttpHelper.getKey(),
            userId: this.user.id,
            token: this.code
            }});

            // console.log(`sendCodeResults: ${JSON.stringify(sendCodeResults.status)}`);

            if(sendCodeResults.status == 200){

              componentsHelpers.toastIt(this.$toasted,
              'Phone was verified, you will be reloaded automatically or you can reload the page manually',
                2, 'outline', true);

              const callReload = this.callReload;

              setTimeout(function(){
                callReload() 
              }, 3000);
              
              // console.log(`before callReload`)
              // this.callReload();
          }
          else{

          }

        }catch(error){

          componentsHelpers.toastIt(this.$toasted, 'Verification failed', 3, 'outline', true);
        }
        

        // console.log(`sendCodeResults is ${JSON.stringify(sendCodeResults)}`);
      }
    },
    
  data: function(){

    return{

      code: '',
      pleaseWaitCode: false,

      language: 1

    }
  }
}
</script>

<style>

</style>